// Croqui: `components/Pill.tsx`.

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';
import { INK_BG, INK_TEXT, TONE_INK, type Tone } from './ink.ts';

/** Status com ponto colorido. O texto só ganha cor nos tons `ok`/`wait`/`bad`. */
export function Pill({
  tone,
  children,
  className,
}: {
  tone: Tone;
  children: ReactNode;
  className?: string;
}) {
  const ink = TONE_INK[tone];
  return (
    <span
      className={cn(
        'inline-flex h-6 items-center gap-[7px] whitespace-nowrap rounded-pill bg-kbd px-2.5 text-12 font-semibold',
        tone === 'neutral' || tone === 'info' ? 'text-text' : INK_TEXT[ink],
        className,
      )}
    >
      <span className={cn('size-[7px] shrink-0 rounded-pill', INK_BG[ink])} />
      {children}
    </span>
  );
}

export type { Tone as PillTone };
